/**
 * Check that a RHF value is a number. Optionally checks it is in a range.
 * @param range - Optional inclusive range to check. If only one number is provided then it is a minimum range.
 * @param isInteger - Forces the number to be a whole integer number.
 * @returns Validator function.
 */
export function isNumber(
  range?: [number] | [number, number],
  isInteger: boolean = true
): (v: string) => string | boolean {
  return (v: string): string | boolean => {
    const parsed = Number(v);

    if (isInteger) {
      if (!Number.isInteger(parsed)) {
        return "Must be an integer";
      }
    }

    if (isNaN(parsed) === true) {
      return "Must be a whole number";
    }

    if (range !== undefined) {
      if (range.length === 2) {
        if (parsed < range[0] || parsed > range[1]) {
          return `Must be between ${range[0]} and ${range[1]}`;
        }
      }

      if (range.length === 1) {
        if (parsed < range[0]) {
          return `Must be greater than ${range[0]}`;
        }
      }
    }

    return true;
  };
}
